export default "__VITE_ASSET__Cj$k_c2J__"